import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick", "id"]
const _hoisted_2 = {
  key: 0,
  class: "tabular-row main-entry"
}
const _hoisted_3 = { class: "main-entry-code" }
const _hoisted_4 = {
  key: 1,
  class: "tabular-row main-entry-instructions"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 2,
  class: "tabular-row regular"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "tabular-row main-entry-selectable" }
const _hoisted_9 = { class: "main-entry-selectable-content" }
const _hoisted_10 = { class: "add-code-chip" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 4,
  class: "instructional-note-excludes"
}
const _hoisted_13 = { class: "exclude-header" }
const _hoisted_14 = { class: "exclude-content" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 5,
  class: "instructional-note-excludes"
}
const _hoisted_17 = { class: "exclude-header include-header" }
const _hoisted_18 = { class: "exclude-content" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 6,
  class: "instructional-note"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, "Note:", -1)
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  key: 7,
  class: "section-title"
}
const _hoisted_24 = { key: 8 }

import {onUpdated, ref, watch, onMounted, onUnmounted} from 'vue';
import { useSearchStore } from 'stores/search-store';
import {storeToRefs} from 'pinia';
import {useGrouperStore} from 'stores/grouper-store';
import {Services} from 'src/services/service-manager';
import {BookViewRecord, SearchService} from 'src/services/search-service';
import { isEmpty } from 'src/common/arrayUtil';
import debounce from 'lodash.debounce';
import {useResourcesStore} from 'stores/resources-store';
import { DATA_BOOK_REGEX } from 'src/components/grouper-common/common-constants';

const SCROLL_THRESHOLD = 150,
  RECORD_INCREMENT = 50;


export default /*#__PURE__*/_defineComponent({
  __name: 'DiagnosisTabularList',
  setup(__props) {


const grouperStore = useGrouperStore();
const searchStore = useSearchStore();
const resourcesStore = useResourcesStore();

let minDataSequence: number, maxDataSequence: number;
const viewType = ref<string>();
const scrollViewTop = ref<boolean>();
const contentRef = ref();
const {searchResultDetails, initialItemRecord, selectedTabularRecordID} = storeToRefs(searchStore);
const trucodeSearchService = Services.service(SearchService);

const tabularDiagnosisData = ref<Array<BookViewRecord>>([]);
let minPreviousSequence: number;
let shouldScroll = false, scrollUp = false;

// This is entry point where click from the left search view performed
watch(searchResultDetails, (newSearchResults) => parseNewResponse(newSearchResults));

onMounted(() => {
  window.addEventListener('keydown', listKeyUp);
});

onUnmounted(() => {
  window.removeEventListener('keydown', listKeyUp);
});

function parseNewResponse(newSearchResults: BookViewRecord[] | undefined) {
  tabularDiagnosisData.value = [];
  scrollUp = false;

  if (isEmpty(newSearchResults)) {
    return;
  }

  viewType.value = newSearchResults?.[0].data_book;
  // Refresh all data
  minDataSequence = initialItemRecord.value?.data_sequence || 0;
  maxDataSequence = initialItemRecord.value?.data_sequence || 0;
  scrollViewTop.value = false;

  if (viewType.value?.endsWith('TABULAR') && !isEmpty(newSearchResults)) {
    shouldScroll = true;
    parseResponseDiagnosisTabular(newSearchResults, true);
  }
}

// We should let data pass to vue and render, then perform scroll
onUpdated(() => {
  if (shouldScroll) {
    setTimeout(() => {
      scrollToHighlight();
    });
    shouldScroll = false;
  }
})

function scrollToHighlight() {
  if (!viewType.value?.endsWith('TABULAR') || !initialItemRecord.value) return;

  if (minPreviousSequence && scrollUp) {
    // We need to scroll to previous top or bottom element otherwise view will jump
    const matchingElement = document.getElementById(`tabular-dx-${minPreviousSequence}`);
    matchingElement?.scrollIntoView();
    makeNodeSelected({data_sequence: minPreviousSequence})
  } else {
    const matchingElement = document.getElementById(`tabular-dx-${initialItemRecord.value?.data_sequence}`);
    matchingElement?.scrollIntoView();
    makeNodeSelected({data_sequence: initialItemRecord.value?.data_sequence})
  }
}

function parseResponseDiagnosisTabular(records: BookViewRecord[], bottom: boolean) {
  if (tabularDiagnosisData.value.length > 0) {
    minPreviousSequence = tabularDiagnosisData.value[0].data_sequence || 0;
  }
  if (bottom) {
    tabularDiagnosisData.value.push(...records);
  } else {
    tabularDiagnosisData.value.unshift(...records);
  }
}

const onScrollDiagnosisTabular = debounce((event) => {
  const el = event.target;

  if (el.scrollTop + el.offsetHeight + 100 > contentRef.value?.clientHeight) {
    maxDataSequence += RECORD_INCREMENT;
    trucodeSearchService.getCodebooksDetails(viewType.value, maxDataSequence, useGrouperStore().patientEffectiveDate).then((resultDetails) => {
      parseResponseDiagnosisTabular(resultDetails, true);
    });
  } else if (el.scrollTop <= SCROLL_THRESHOLD && minDataSequence > 50) {
    el.scrollTop = SCROLL_THRESHOLD + 1
    minDataSequence -= RECORD_INCREMENT;
    shouldScroll = scrollUp = true;
    trucodeSearchService.getCodebooksDetails(viewType.value, minDataSequence, useGrouperStore().patientEffectiveDate).then((resultDetails) => {
      parseResponseDiagnosisTabular(resultDetails, false);

    });
  }
}, 100);

function getExcludeText(content: string) {

  if (content.startsWith('Excludes') || content.startsWith('Includes')) {
    // Strip off ExcludesN: or Includes: in content itself, we add this styled manually
    return content.substring(content.indexOf(':') + 1);
  } else {
    return content;
  }
}

function trucodeEmbeddedClickHandler(event: any) {

  if (event?.target?.dataset?.codeType == 'ICD10CM_DX' || event?.target?.dataset?.codeType == 'ICD10CM_E') {

    const code = event?.target?.innerText;
    if (code) {
      searchStore.focusIndexItem(code, undefined, true);
    }
  }
}

async function addDiagnosisCode(code: string, description: string, data_book: string) {
  grouperStore.addDiagnosisCode(code, description, undefined, true);
  await resourcesStore.getResearch(code, data_book.match(DATA_BOOK_REGEX)[0]);
}

function diagnosisTabClasses(record) {
  let classes = `diagnosis-tab-row shift-${record.record.level}`
  if(record.data_sequence === selectedTabularRecordID?.value) {
    classes += ' selected-row';
  }
  return classes;
}

function makeNodeSelected(node: any) {
  searchStore.selectedTabularRecordID = node.data_sequence
}

function listKeyUp(event: KeyboardEvent) {
  if (['ArrowUp', 'ArrowDown', 'Enter', 'Tab'].includes(event.key) && viewType.value?.endsWith('TABULAR') && !activeElementInSearchBlock()) {
    event.preventDefault();
    const data = tabularDiagnosisData.value;
    let selectedIndex = data.findIndex(item => item.data_sequence === selectedTabularRecordID.value);
    selectedIndex = selectedIndex === -1 ? 0 : selectedIndex;

    const record = data[selectedIndex];
    const data_sequence = record.data_sequence;
    const scrollableContainer = document.getElementById("scrollable-container");
    if (event.key === 'Enter') {
      if(record.record.type === 'mainentryselectable') {
        addDiagnosisCode(record.record.codes[0].startcode, record.record.content, record.data_book)
      }
    } else if (event.key === 'ArrowDown' || event.key === 'Tab') {
      const sequence = findSelectableNode(data, selectedIndex, true)
      const matchingElement = document.getElementById(`tabular-dx-${sequence}`);
      if(!isInScrollableViewport(matchingElement, scrollableContainer)) {
        matchingElement?.scrollIntoView();
      }
      makeNodeSelected({data_sequence: sequence})
    } else if (event.key === 'ArrowUp') {
      const sequence = findSelectableNode(data, selectedIndex, false)
      const matchingElement = document.getElementById(`tabular-dx-${sequence}`);
      if(!isInScrollableViewport(matchingElement, scrollableContainer)) {
        matchingElement?.scrollIntoView();
      }
      makeNodeSelected({data_sequence: sequence})
    }
  }
}

function findSelectableNode(data, selectedIndex, isNext) {
  let nextIndex = selectedIndex;
  while(true) {
    nextIndex = isNext? ++nextIndex : --nextIndex;
    if((isNext && data.length > nextIndex) || (!isNext && nextIndex >=0)) {
      if(data[nextIndex].record.type === "mainentryselectable") {
        return data[nextIndex].data_sequence;
      }
    } else {
      return data[selectedIndex].data_sequence;
    }
  }
}

function activeElementInSearchBlock() {
  return !!document.activeElement.closest(".search-search-results-content-container")
}

function isInScrollableViewport(element, scrollableContainer) {
  const elementRect = element.getBoundingClientRect();
  const containerRect = scrollableContainer.getBoundingClientRect();

  return (
      elementRect.top >= containerRect.top &&
      elementRect.left >= containerRect.left &&
      elementRect.bottom <= containerRect.bottom &&
      elementRect.right <= containerRect.right
  );
}


return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "iodine-scrollable-y browse-search",
    id: "scrollable-container",
    onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onScrollDiagnosisTabular) && _unref(onScrollDiagnosisTabular)(...args)))
  }, [
    _createElementVNode("div", {
      ref_key: "contentRef",
      ref: contentRef
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabularDiagnosisData.value, (record, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("div", {
            onClick: ($event: any) => (makeNodeSelected(record)),
            class: _normalizeClass(diagnosisTabClasses(record)),
            id: `tabular-dx-${record.data_sequence}`
          }, [
            (record.record.type === 'mainentry' && record.record.codes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", null, _toDisplayString(record.record.content), 1),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(record.record.codes[0].startcode), 1)
                ]))
              : (record.record.type === 'mainentry')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.record.instructional_note_data?.segments, (segment, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", {
                          innerHTML: segment.content
                        }, null, 8, _hoisted_5)
                      ]))
                    }), 128))
                  ]))
                : (record.record.type === 'regular')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.record.regular_note_data?.segments, (segment, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createElementVNode("div", {
                            innerHTML: segment.content
                          }, null, 8, _hoisted_7)
                        ]))
                      }), 128))
                    ]))
                  : (record.record.type === 'mainentryselectable')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (record?.record?.hasinstructionalnotes && record?.data_sequence == _unref(initialItemRecord)?.data_sequence)
                          ? (_openBlock(), _createBlock(_component_q_icon, {
                              key: 0,
                              name: "fa-light fa-circle-info",
                              class: "io-mfe-ig-icon-large io-mfe-ig-instructional-icon"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_tooltip, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Instructional Notes ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            (record.record.subtypes[0] && record.record.subtypes[0].name === 'complication-comorbid')
                              ? (_openBlock(), _createBlock(_component_q_chip, {
                                  key: 0,
                                  class: "CC"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("CC")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (record.record.subtypes[0] && record.record.subtypes[0].name === 'major-complication-comorbid')
                              ? (_openBlock(), _createBlock(_component_q_chip, {
                                  key: 1,
                                  class: "MCC"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("MCC")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(record.record.content) + " ", 1),
                            (record.record.hccs)
                              ? (_openBlock(), _createBlock(_component_q_chip, {
                                  key: 2,
                                  class: "HCC"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("HCC")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", {
                              class: "add-code-button",
                              onClick: ($event: any) => (addDiagnosisCode(record.record.codes[0].startcode, record.record.content, record.data_book))
                            }, [
                              _createVNode(_component_q_tooltip, {
                                anchor: "bottom middle",
                                self: "center middle"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Add Code ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_icon, {
                                class: "code-icon",
                                name: "fa-light fa-circle-plus",
                                size: "14px"
                              }),
                              _createTextVNode(_toDisplayString(record.record.codes[0].startcode), 1)
                            ], 8, _hoisted_11)
                          ])
                        ])
                      ], 64))
                    : (record.record.type === 'instructionalnote' && record.record.instructional_note_data &&
            record.record.instructional_note_data.type.startsWith('excludes'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(record.record.instructional_note_data.type) + ":", 1),
                          _createElementVNode("div", _hoisted_14, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.record.instructional_note_data?.segments, (segment, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                onClick: trucodeEmbeddedClickHandler
                              }, [
                                _createElementVNode("div", {
                                  innerHTML: getExcludeText(segment.content)
                                }, null, 8, _hoisted_15)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : (record.record.type === 'instructionalnote' && record.record.instructional_note_data &&
            record.record.instructional_note_data.type.startsWith('includes'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, _toDisplayString(record.record.instructional_note_data.type) + ":", 1),
                            _createElementVNode("div", _hoisted_18, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.record.instructional_note_data?.segments, (segment, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  onClick: trucodeEmbeddedClickHandler
                                }, [
                                  _createElementVNode("div", {
                                    innerHTML: getExcludeText(segment.content)
                                  }, null, 8, _hoisted_19)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : (record.record.type === 'instructionalnote')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _hoisted_21,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.record.instructional_note_data?.segments, (segment, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "instructional-note-segment",
                                  key: index,
                                  onClick: trucodeEmbeddedClickHandler
                                }, [
                                  _createElementVNode("div", {
                                    innerHTML: segment.content
                                  }, null, 8, _hoisted_22)
                                ]))
                              }), 128))
                            ]))
                          : (record.record.type === 'sectiontitle')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createElementVNode("div", null, _toDisplayString(record.record.content) + " (" + _toDisplayString(record.record.codes[0].startcode) + " - " + _toDisplayString(record.record.codes[1]?.startcode) + ")", 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("div", null, "implement me " + _toDisplayString(record.record.type), 1)
                              ]))
          ], 10, _hoisted_1)
        ]))
      }), 128))
    ], 512)
  ], 32))
}
}

})